export const getWidestRowWidth = (container: HTMLElement): number =>
  Array.from(container.children).reduce(
    (widest, row) => Math.max(widest, row.scrollWidth),
    0,
  );
